export default "__VITE_ASSET__47f3f24e__"